import React from 'react'

//The Redux magic starts here. Access them anywhere directly without importting and stuff
import {useSelector, useDispatch} from 'react-redux'
import {toggleListItem, addItem, clearItems, saveItems, changeMode, addMain} from './actions'



function App() {
	const dispatch = useDispatch()
	const itemList = useSelector(state => state.itemList)
	const mode = useSelector(state => state.currentMode)
	let inputRef = React.createRef()


	//Bruh.. very simple form handling. But don't overuse REF.
	function handleClick(event) {
		if (event.key == "Enter") {
			dispatch(addItem(inputRef.current.value,mode.main))
			inputRef.current.value = ""
		}
	}

	function handleMainClick() {
		dispatch(addMain(inputRef.current.value))
		inputRef.current.value = ""
	}


	//PRERENDER
	let renderedMenuList = itemList.map((x,i) => <li onClick = {() => dispatch(changeMode("goToItem",i))}> {x.mainName}</li>)
	let renderedItemList = []
	if (mode.main !== null) {
		renderedItemList = itemList[mode.main].content.map( (obj,ind) => <li onClick = {() => dispatch(toggleListItem(ind,mode.main))}> {!obj.isDone ? obj.text : <s>{obj.text}</s>} </li>)
	} 

	
	if (mode.view == "HOME") {
		return (
		<div className = 'container'>
			<div className = 'row'>
				<div className = 'column'>
					<h1> // TODO </h1>
					<label><i className='far fa-folder-open'></i> home </label>
					<p>click on list to open it, or create a new list!</p>
					
					<ul>
						{renderedMenuList}
					</ul>
				</div>
			</div>

			<div className = 'row'>
			<div className = 'column'>
				<input className="mainbox" type='text' ref = {inputRef}/>
			</div>
			<div className = 'column'>
				<button className='button button-clear' onClick={handleMainClick}> create new list </button>
				<button className = 'button button-clear' onClick = {() => dispatch(saveItems())}> SAVE </button>
			</div>
				 
		</div> 

		</div>
		)
	}



	//this is bad
	if (mode.view == "ITEM") {
	return(
	<div className = 'container'>
		<div className = 'row'>
			<div className = 'column'>
					<h1> // TODO </h1>
					<label><i className='far fa-folder-open'></i> home &middot; {itemList[mode.main].mainName} </label>
					<ul>
						{renderedItemList}
							 	

					</ul>
			</div>
		</div>

		<div className = 'row'>
			<div className = 'column'>
				<input type='text' ref = {inputRef} onKeyDown = {handleClick}/>
			</div>
			<div className = 'column'>
				
				<button className = 'button button-clear' onClick = {() => dispatch(clearItems(mode.main))}> CLEAR </button>
				<button className = 'button button-clear' onClick = {() => dispatch(saveItems())}> SAVE </button>
				<button className = 'button' onClick = {() => dispatch(changeMode('goToHome',null))}> EXIT </button>
			</div>
				 
		</div> 


	</div>
	)}
}





export default App	